import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import { ThemeProvider } from '@mui/material/styles';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { darkTheme } from '../../styles/materialTheme';
import { PlayerInfoActionsMenuItems } from './playerInfoActionsMenuItems';
export const PlayerInfoActionsMenuButton = ({ playerInfo, isFriend }) => {
    const popupState = usePopupState({ variant: 'popover' });
    const closeMenu = popupState.close;
    return (_jsxs("div", { children: [_jsx(IconButton, { size: 'small', title: 'Actions', color: 'primary', ...bindTrigger(popupState), children: _jsx(MenuRoundedIcon, {}) }), _jsx(ThemeProvider, { theme: darkTheme, children: _jsx(Menu, { ...bindMenu(popupState), children: _jsx(PlayerInfoActionsMenuItems, { playerInfo: playerInfo, isFriend: isFriend, closeMenu: closeMenu }) }) })] }));
};
